<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="epigraph ParaOverride-3" lang="en-US">A day and another day and the day before, and the library with the big boys in the shelves, old Dreiser, old Mencken, all the boys down there, and I went to see them, Hya Dreiser, Hya Mencken, Hya, hya: there’s a place for me, too, and it begins with B, in the B shelf, Arturo Bandini, make way for Arturo Bandini, his slot for his book, and I sat at the table and just looked at the place where my book would be, right there close to Arnold Bennett; not much that Arnold Bennett, but I’d be there to sort of bolster up the B’s, old Arturo Bandini … </p>
<p class="epigraph-right" lang="en-US">John Fante, <em class="italic">Ask the Dust</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RonCarlson-28.vue?57946377